@import '~style-sheet-helpers/core.less';
@import '../../../app-brand/entities/entity-layer.module.less';
@import '../../../constants/spacing.module.less';

.modal {
  width: 800px;
  height: 600px;
}

.body {
  display: flex;
  height: calc(100% - 100px);
}

.left-pane {
  min-width: 550px;
  background-color: @multi-package-modal--left-pane--background-color;
  height: 100%;

  .sub-header {
    display: flex;
    align-items: center;
    height: 50px;
    background-color: @multi-package-modal--left-pane-header--background-color;
    border-bottom: 1px solid @multi-package-modal--left-pane-header--border-color;
    padding: 10px 15px;
  }
}

.package-sets-dropdown {
  margin-left: 15px;
}

.left-pane-for-settings {
  &:extend(.left-pane all);

  .sub-header {
    height: auto;
    align-items: flex-end;
  }
}

.package-set-name-input {
  flex-grow: 2;
  margin-right: 15px;
}

.package-set {
  padding: 15px;
  overflow: auto;
  height: calc(100% - 50px);
  box-shadow: inset 0 0 4px @multi-package-modal--set--box-shadow-color;
}

.package-container {
  margin-bottom: 15px;

  &:last-child {
    margin-bottom: 0;
  }
}

.right-pane {
  border-left: 1px solid @multi-package-modal--right-pane--border-color;
  width: 100%;

  > div {
    padding: 15px;
  }

  .package-count {
    border-bottom: 1px solid @multi-package-modal--right-pane--border-color;
    font-size: 20px;
    width: 100%;
    display: flex;
    align-items: center;

    .badge {
      background: @multi-package-modal--right-pane-badge--background-color;
      margin-right: 10px;
      font-weight: @bold;
      width: auto;
      height: 30px;
      padding: 0 10px;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }

  .package-set-details {
    font-size: 16px;

    > div {
      padding-bottom: 10px;
    }

    > .details-weight {
      padding-bottom: 15px;
      border-bottom: 1px solid @multi-package-modal--right-pane-set-details--border-color;
      margin-bottom: 15px;
    }

    .details-label {
      color: @multi-package-modal--right-pane-set-details--text-color;
      margin-right: 10px;
    }
  }
}

.footer {
  padding: 15px;
  border-top: 1px solid @multi-package-modal--footer--border-color;
  display: flex;
  align-items: center;
  justify-content: space-between;

  .spacer {
    width: 10px;
  }

  .footer-buttons {
    display: flex;
    flex-direction: row;
  }

  .package-set-name {
    margin-left: 10px;
  }

  .new-packages {
    display: flex;
    align-items: center;
    flex-direction: row;
  }
}

.footer-for-settings {
  &:extend(.footer all);

  justify-content: flex-end;
}

.dropdown-button {
  border-radius: 0 4px 4px 0;
}

.button-group {
  display: flex;
}

.add-package-dropdown {
  margin-left: -2px;
  border-left: 1px solid @white;
}

.package-set-dropdown {
  padding: 0;
}

.package-set-button {
  display: flex;
  justify-content: space-between;
}

.package-set-name {
  padding: 10px;
}

.x-button {
  height: 30px;
  width: 30px;
  cursor: pointer;
  display: flex;
  align-self: center;
  align-items: center;
  justify-content: center;
  &:hover {
    > svg {
      opacity: 1;
    }
  }

  > svg {
    height: 16px;
    width: 16px;
    color: @multi-package-modal--x-button--fill-color;
    opacity: 0.5;
  }
}

.read-only {
  .sub-header {
    display: none;
  }

  .package-set {
    height: 100%;
  }

  .footer {
    .new-packages {
      display: none;
    }

    .footer-buttons {
      display: none;
    }
  }
}

.multi-package-not-supported-banner {
  margin-bottom: @space-16;
}
